import {Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {AppService} from "../../core/services/app.service";

@Injectable({
  providedIn: 'root'
})

export class PartnerService {
  constructor(public http: HttpClient) {
  }

  public static partnerAPI = AppService.getApiUrl() + '/api/partners/';
}
